// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tray-pieces-container {
  position: relative; 
  width: 100%; /* Занимает всю ширину родителя */
  /* height будет определяться контентом */
  z-index: 480; /* Оставляем z-index */

  touch-action: auto;
}

.tray-piece-item {
  position: absolute; 
  will-change: transform; 
  pointer-events: auto; 
  touch-action: auto;
}


.tray-piece-item.debug {
  outline: 1px solid #eae056;
}

.tray-piece-item.ghost {
  opacity: 0.15; /* Прозрачность для "призраков", можно взять из config.ghostOpacity */
  filter: grayscale(80%) brightness(1.1); /* Эффекты как в pieceRenderer */
  pointer-events: none; /* Позволяет событиям проходить сквозь "призрак" */
  /* touch-action: auto; - Убираем, не нужно */
}

/* Добавляем правило для дочерних элементов призрака */
.tray-piece-item.ghost > * {
  pointer-events: none;
}

.tray-piece-item.reserved {
  opacity: 0;
  pointer-events: none;
}

.tray-piece-item > * {
  pointer-events: auto; /* Включаем клики только по самому Canvas/SVG */
}

.scroll-indicator {
  position: absolute;
  right: 10px; /* Отступ справа */
  top: 50%; /* Центрируем по вертикали */
  transform: translateY(-50%);
  font-size: 32px; /* Размер иконки */
  color: rgba(128, 128, 128, 0.6); /* Полупрозрачный серый */
  pointer-events: none; /* Иконка не должна мешать взаимодействию */
  z-index: 1; /* Поверх фона, но ниже интерактивных элементов */
}
`, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/pieces/TrayPieces.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW,EAAE,iCAAiC;EAC9C,wCAAwC;EACxC,YAAY,EAAE,sBAAsB;;EAEpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa,EAAE,qEAAqE;EACpF,sCAAsC,EAAE,gCAAgC;EACxE,oBAAoB,EAAE,kDAAkD;EACxE,4CAA4C;AAC9C;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB,EAAE,+CAA+C;AACvE;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,kBAAkB;EAC/B,QAAQ,EAAE,4BAA4B;EACtC,2BAA2B;EAC3B,eAAe,EAAE,kBAAkB;EACnC,+BAA+B,EAAE,yBAAyB;EAC1D,oBAAoB,EAAE,2CAA2C;EACjE,UAAU,EAAE,iDAAiD;AAC/D","sourcesContent":[".tray-pieces-container {\r\n  position: relative; \r\n  width: 100%; /* Занимает всю ширину родителя */\r\n  /* height будет определяться контентом */\r\n  z-index: 480; /* Оставляем z-index */\r\n\r\n  touch-action: auto;\r\n}\r\n\r\n.tray-piece-item {\r\n  position: absolute; \r\n  will-change: transform; \r\n  pointer-events: auto; \r\n  touch-action: auto;\r\n}\r\n\r\n\r\n.tray-piece-item.debug {\r\n  outline: 1px solid #eae056;\r\n}\r\n\r\n.tray-piece-item.ghost {\r\n  opacity: 0.15; /* Прозрачность для \"призраков\", можно взять из config.ghostOpacity */\r\n  filter: grayscale(80%) brightness(1.1); /* Эффекты как в pieceRenderer */\r\n  pointer-events: none; /* Позволяет событиям проходить сквозь \"призрак\" */\r\n  /* touch-action: auto; - Убираем, не нужно */\r\n}\r\n\r\n/* Добавляем правило для дочерних элементов призрака */\r\n.tray-piece-item.ghost > * {\r\n  pointer-events: none;\r\n}\r\n\r\n.tray-piece-item.reserved {\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.tray-piece-item > * {\r\n  pointer-events: auto; /* Включаем клики только по самому Canvas/SVG */\r\n}\r\n\r\n.scroll-indicator {\r\n  position: absolute;\r\n  right: 10px; /* Отступ справа */\r\n  top: 50%; /* Центрируем по вертикали */\r\n  transform: translateY(-50%);\r\n  font-size: 32px; /* Размер иконки */\r\n  color: rgba(128, 128, 128, 0.6); /* Полупрозрачный серый */\r\n  pointer-events: none; /* Иконка не должна мешать взаимодействию */\r\n  z-index: 1; /* Поверх фона, но ниже интерактивных элементов */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
